<template>
  <div class="pc-bp">
    <!-- 院校头部面包屑部分 -->
    <div class="pc-bp-bread">
      <h2>BP列表</h2>
      <BreadCrumb :data="breadcrumb" class="pc-new-breadcrumb" />
    </div>

    <!-- bp基本信息 -->
    <div v-show="editAwards == false" class="pc-practiceAwardArgs-information">
      <div class="pc-practiceAwardArgs-title">
        <h2>基本信息</h2>
        <h4 v-show="editAwards == false" @click="edit">编辑</h4>
      </div>
      <div class="pc-practiceAwardArgs-information-contain">
        <!-- 左边边图片 -->
        <div class="pc-practiceAwardArgs-information-contain-img">
          <div v-if="practiceAwardArgs.image != null" class="logo-Img">
            <img :src="practiceAwardArgs.image" />
          </div>
          <div v-if="practiceAwardArgs.image == null" class="not-Img">
            <span>暂无图片</span>
          </div>
          <div
            v-if="practiceAwardArgs.coverImage != null"
            class="background-Img"
          >
            <img :src="practiceAwardArgs.coverImage" />
          </div>
        </div>
        <!-- 右边文字内容 -->
        <ul class="pc-practiceAwardArgs-information-contain-word">
          <li>
            <h4>中文名：</h4>
            <span>{{ practiceAwardArgs.name }}</span>
          </li>
          <li>
            <h4>英文名：</h4>
            <span>{{ practiceAwardArgs.englishName }}</span>
          </li>
          <li>
            <h4>名称缩写：</h4>
            <span>{{ practiceAwardArgs.shortName }}</span>
          </li>
          <li>
            <h4>奖项分类：</h4>
            <el-radio-group
              v-if="practiceAwardArgs.category != null"
              v-model="practiceAwardArgs.category"
              size="small"
            >
              <el-radio label="PaperAward" disabled>作品奖项</el-radio>
              <el-radio label="PersonAward" disabled>人物奖项</el-radio>
            </el-radio-group>

            <div v-if="practiceAwardArgs.category == null">
              <el-radio-group v-model="category" size="small">
                <el-radio label="1" disabled>作品奖项</el-radio>
                <el-radio label="2" disabled>人物奖项</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li>
            <h4>奖项类型：</h4>
            <span>{{ practiceAwardArgs.type }}</span>
          </li>
          <li class="pc-practiceAwardArgs-information-contain-intro">
            <h4>中文简介：</h4>
            <span v-if="practiceAwardArgs.intro != null">{{
              practiceAwardArgs.intro
            }}</span>
            <span v-if="practiceAwardArgs.intro == null">暂无</span>
          </li>
          <li class="pc-practiceAwardArgs-information-contain-intro">
            <h4>英文简介：</h4>
            <span v-if="practiceAwardArgs.englishIntro != null">{{
              practiceAwardArgs.englishIntro
            }}</span>
            <span v-if="practiceAwardArgs.englishIntro == null">暂无</span>
          </li>
          <li>
            <h4>状态：</h4>
            <span v-if="practiceAwardArgs.status == 0">失效</span>
            <span v-if="practiceAwardArgs.status == 1">有效</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 修改大学详情基本信息页 -->
    <div v-show="editAwards == true" class="pc-practiceAwardArgs-information">
      <div class="pc-practiceAwardArgs-title">
        <h2>修改信息</h2>
        <h4
          v-show="awardAdd == 'update'"
          @click="
            edit();
            saveArea();
          "
        >
          完成
        </h4>
        <h4
          v-show="awardAdd == 'add'"
          @click="
            edit();
            addArea();
          "
        >
          新增
        </h4>
      </div>
      <div class="pc-practiceAwardArgs-information-contain">
        <!-- 左边边图片 -->
        <div class="pc-practiceAwardArgs-information-contain-img">
          <div class="pc-uploadLogoFile">
            <el-upload
              class="logoImg"
              v-if="editAwards && percentageImage == 0"
              :action="uploadUrl"
              list-type="picture-card"
              accept=".png,.PNG,.jpg,.JPG,.jpeg"
              :http-request="uploadLogoFile"
              :show-file-list="false"
              :auto-upload="true"
            >
              <img
                v-if="practiceAwardArgs.image"
                :src="practiceAwardArgs.image"
                class="upload-image"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="percentageImage">
              <el-progress
                v-if="percentageImage != 0"
                type="circle"
                :width="100"
                :percentage="percentageImage"
              ></el-progress>
            </div>
          </div>

          <span>奖项logo</span>
          <el-input v-model="practiceAwardArgs.image"></el-input>
          <div class="pc-uploadBGFile">
            <el-upload
              :action="uploadUrl"
              v-if="percentageCoverImage == 0"
              list-type="picture-card"
              accept=".png,.PNG,.jpg,.JPG,.jpeg"
              :http-request="uploadBGFile"
              :show-file-list="false"
              class="bgImage"
              :auto-upload="true"
            >
              <img
                v-if="practiceAwardArgs.coverImage"
                :src="practiceAwardArgs.coverImage"
                class="upload-image"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
                 <div class="percentageCoverImage">
              <el-progress
                v-if="percentageCoverImage != 0"
                type="circle"
                :width="100"
                :percentage="percentageCoverImage"
              ></el-progress>
            </div>
          </div>

          <span>奖项banner</span>
          <el-input v-model="practiceAwardArgs.coverImage"></el-input>
        </div>
        <!-- 右边文字内容 -->
        <ul class="pc-practiceAwardArgs-information-contain-word">
          <li>
            <h4>中文名：</h4>
            <el-input v-model="practiceAwardArgs.name"></el-input>
          </li>
          <li>
            <h4>英文名：</h4>
            <el-input v-model="practiceAwardArgs.englishName"></el-input>
          </li>
          <li>
            <h4>英文缩写：</h4>
            <el-input v-model="practiceAwardArgs.shortName"></el-input>
          </li>
          <li>
            <h4>实项分类：</h4>
            <!-- <el-input v-model="practiceAwardArgs.category"></el-input> -->
            <el-radio-group v-model="practiceAwardArgs.category" size="small">
              <el-radio label="PaperAward" @change="getContinentDicList"
                >作品奖项</el-radio
              >
              <el-radio label="PersonAward" @change="getPersonContinentDicList"
                >人物奖项</el-radio
              >
            </el-radio-group>
          </li>
          <li>
            <h4>奖项类型：</h4>
            <!-- <el-input v-model="practiceAwardArgs.type"></el-input> -->
            <el-select v-model="practiceAwardArgs.type" placeholder="">
              <el-option
                v-for="(item, index) in awardType"
                :key="index"
                :value="item.name ? item.name : item.name"
                :label="item.name ? item.name : item.name"
              >
              </el-option>
            </el-select>
          </li>

          <li class="pc-practiceAwardArgs-information-contain-intro">
            <h4>中文简介：</h4>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="practiceAwardArgs.intro"
            >
            </el-input>
          </li>
          <li class="pc-practiceAwardArgs-information-contain-intro">
            <h4>英文简介：</h4>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="practiceAwardArgs.englishIntro"
            >
            </el-input>
          </li>
          <li>
            <h4>状态：</h4>
            <el-switch
              v-model="practiceAwardArgs.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <!-- bp表格 -->
    <div class="pc-bp-table">
      <BestPracticeTable v-if="practiceAwardArgs.category == 'PaperAward'" />
      <PersonTable v-if="practiceAwardArgs.category == 'PersonAward'" />
    </div>

    <!-- 面板 -->
    <!-- <div
      v-show="searchTemplete"
      @click="hideSearch"
      class="search-templete"
    ></div> -->
  </div>
</template>
<script>
import BreadCrumb from "../../template/BreadCrumb";

import BestPracticeTable from "./components/BestPracticeTable";
import PersonTable from "./components/personTable";
import {
  getPracticeAward,
  updatePracticeAward,
  addPracticeAward,
  getDictionaries,
} from "./awards.gql";
export default {
  components: {
    BreadCrumb,
    BestPracticeTable,
    PersonTable,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "BP管理", link: "/" },
        { name: "BP列表", link: "bestpractice/" },
        { name: "" + this.breadName + "奖项", link: "" },
      ];
    },
  },
  data() {
    return {
      percentageCoverImage: 0,
      percentageImage:0,
      // 临时数据
      checked: "作品奖项",
      checkeds: false,
      // 单选按钮
      personAward: "",
      // 需要新增
      awardAdd: "",
      // 上传图片初始URL
      uploadUrl: "",
      // 奖项类型下拉框
      awardType: [],
      // 该详情页的ID
      awardsId: 0,
      // 详情页数据
      practiceAwardArgs: {},
      // 详情页初始化数据
      category: 0,
      editAwards: false,
      // 奖项详情页面包
      breadName: "",
      // 后端需要的参数
      dailyStatisticsesArgs: {
        fromCurrentDate: "",
        toCurrentDate: "",
      },
      checkedProduction: false,
      // 奖项接口后端需要的接口
      practiceAwardsArgs: {
        skip: 0,
        take: 12,
        total: 0,
        cell: 0,
      },

      form: {
        tagType: "",
        tag: "",
        type: [],
      },
      // 查询选中是哪个标签
      secondLevel: [],
      // 底色模板
      searchTemplete: false,
    };
  },
  created() {
    if (this.$route.query.id == null) {
      this.awardAdd = "add";
      this.edit();
    } else {
      this.awardAdd = "update";
      this.awardsId = this.$route.query.id;
      this.getPracticeAward();
    }
  },
  mounted() {},
  methods: {
    // 获取人物奖项类型
    getPersonContinentDicList() {
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          type: "bp_awards_category_person",
        })
        .then((res) => {
          this.awardType = res.data;
          // this.tag[0].tagList = res.data;
        });
    },
    // 获取作品奖项类型
    getContinentDicList() {
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          type: "bp_awards_category_practice",
        })
        .then((res) => {
          this.awardType = res.data;
        });
    },
    // 初始化奖项详情数据
    getPracticeAward() {
      this.$global
        .GraphqlQuery(this, getPracticeAward, {
          id: this.awardsId,
        })
        .then((res) => {
          if(res.data[0].name==null){
            this.breadName = res.data[0].englishName
          }else{
            this.breadName = res.data[0].name;
          }
          this.practiceAwardArgs = res.data[0];
          if (res.data[0].category == "PaperAward") {
            this.getContinentDicList();
          } else if (res.data[0].category == "PersonAward") {
            this.getPersonContinentDicList();
          }
        });
    },
    // 编辑信息
    edit() {
      this.managerState = (this.managerState == false) == true ? true : false;
      this.editAwards = (this.editAwards == false) == true ? true : false;
    },

    addArea() {
      this.$global
        .GraphqlMutation(this, addPracticeAward, {
          // Parameters
          data: this.$global.checkNull(this.practiceAwardArgs),
        })
        .then((res) => {
          this.awardsId = res.data[0].id;
          this.awardAdd = "update";
          this.$router.push({
            path: "/admin/awardslist",
            query: { id: res.data[0].id },
            name: "awardslist",
            params: res.data[0],
          });
          this.getPracticeAward();
          // this.getPractice();
        });
    },
    // 提交编辑信息
    saveArea() {
      let {
        name,
        englishName,
        shortName,
        intro,
        englishIntro,
        type,
        coverImage,
        image,
        status,
        category,
      } = this.practiceAwardArgs;
      const subEntity = {
        name,
        englishName,
        shortName,
        intro,
        englishIntro,
        type,
        image,
        coverImage,
        status,
        category,
      };
      this.$global
        .GraphqlMutation(this, updatePracticeAward, {
          // Parameters
          id: this.practiceAwardArgs.id,
          data: this.$global.checkNull(subEntity),
        })
        .then((res) => {
          this.$global.success(this, "操作成功");
          this.getPracticeAward();
        });
    },
    // 移除该分类标签
    removeTypeTag(indexs, index) {
      this.tag[index].tagList.splice(indexs, 1);
    },
    // 上传头像
    async uploadLogoFile(params) {
      let that = this;
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          that.percentageImage = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.percentageImage = 0;
        this.$set(this.practiceAwardArgs, "image", res.url.split("?")[0]);
      });
      // this.$global.uploadImage(this, params).then((res) => {
      //   this.practiceAwardArgs.image = res.split("?")[0];
      // });
    },
    async uploadBGFile(params) {
        let that = this;
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          that.percentageCoverImage = parseInt(process);
        },
      };
       this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.percentageCoverImage = 0;
        this.$set(this.practiceAwardArgs, "coverImage", res.url.split("?")[0]);
      });
      // this.$global.uploadImage(this, params).then((res) => {
      //   this.practiceAwardArgs.coverImage = res.split("?")[0];
      // });
    },
    // 管理标签
    tagManager() {
      this.managerState = true;
      this.managericon = true;
    },
    // 管理奖项的编辑按钮
    awardsManager() {
      this.managerAwardsState = true;
    },
    // 管理标签的保存按钮
    tagManagerSave() {
      this.managerState = false;
      this.managericon = false;
    },
    // 管理奖项的保存按钮
    awardsManagerSave() {
      this.managerAwardsState = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-bp {
  // bp头部面包屑部分
  .pc-bp-bread {
    display: flex;
    padding-bottom: 20px;
    border-bottom: 2px solid $border-color;
    > h2 {
      font-size: 20px;
      padding: 35px 40px 0 0;
      align-self: flex-end;
    }
  }
  .pc-practiceAwardArgs-information {
    box-shadow: $boxshadow;
    padding: 35px 30px;
    margin-top: 40px;
    > h2 {
      border-bottom: 2px solid $border-color;
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    .pc-practiceAwardArgs-title {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid $border-color;
      padding-bottom: 15px;
      h2 {
        align-self: flex-end;
        font-size: 20px;
        margin-right: 40px;
      }
      h4 {
        align-self: flex-end;
        font-size: 16px;
        background: $pageViewSmall;
        padding: 10px 29px 14px;
        font-weight: 400;
        color: $base-color;
        font-family: $english;
        border-radius: 4px;
        cursor: pointer;
      }
    }
    // 基本信息的内容框
    .pc-practiceAwardArgs-information-contain {
      // border: 1px solid red;
      padding-top: 34px;
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      .pc-practiceAwardArgs-information-contain-img {
        display: flex;
        flex-direction: column;
        .pc-uploadLogoFile {
          position: relative;
          height: 100px;
          .percentageImage {
            position: absolute;
            top: 0;
          }
        }
        .pc-uploadBGFile{
           position: relative;
          height: 120px;
          width: 220px;
          .percentageCoverImage {
            position: absolute;
            top: 20px;
            left: 60px;
          }
        }
        .not-Img {
          width: 111px;
          height: 111px;
          display: flex;
          justify-content: center;
          border: 1px solid $universityBackground;
          span {
            align-self: center;
          }
        }
        /deep/ .logoImg {
          .el-upload--picture-card {
            width: 100px;
            height: 100px;
            line-height: 106px;

            img {
              // width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
        /deep/ .bgImage {
          .el-upload--picture-card {
            margin-top: 20px;
            width: 220px;
            height: 100px;
            line-height: 106px;
            img {
              // width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
        .logo-Img {
          width: 111px;
          height: 111px;
          // display: flex;
          flex-direction: column;
          img {
            // width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .background-Img {
          width: 325px;
          height: 178px;
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          img {
            // width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
      // 院校简介内容部分
      .pc-practiceAwardArgs-information-contain-word {
        display: flex;
        flex-wrap: wrap;
        // justify-content: flex-end;
        li {
          display: flex;
          font-size: 14px;
          color: $mainTitle;
          font-family: $english;
          width: 50%;
          margin-bottom: 45px;
          h4 {
            width: 100px;
            min-width: 100px;
            text-align: right;
            margin-right: 20px;
            font-weight: 400;
            align-self: center;
          }
          .el-form {
            display: flex;
            .el-select {
              margin-right: 20px;
            }
          }
          span {
            font-weight: 600;
            word-break: normal;
            width: auto;
            display: block;
            white-space: pre-wrap;
            word-wrap: break-word;
            overflow: hidden;
            align-self: center;
          }
        }
        li:last-child {
          // width: 100%;
          position: relative;
          h4 {
            width: 100px;
            min-width: 100px;
            text-align: right;
            margin-right: 20px;
            font-weight: 400;
          }
          span {
            position: absolute;
            font-weight: 600;
            left: 120px;
            width: 224%;
          }
        }
        .area-li {
          .area-li-div {
            display: flex;
            span {
              margin-right: 20px;
            }
          }
        }
      }
      // 院校简介内容底部的简介部分
      .pc-practiceAwardArgs-information-contain-intro {
        /deep/ .el-textarea__inner {
          resize: none !important;
        }
      }
    }
  }
  // bp表单
  .pc-bp-table {
    // box-shadow: $boxshadow;
    // padding: 35px 30px;
    margin-top: 40px;
    // margin-right: 40px;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
      border-bottom: 2px solid $border-color;
    }
  }
  // 模块
  .search-templete {
    width: 100vw;
    height: 100vh;
    background: black;
    position: fixed;
    top: 0;
    opacity: 0;
  }
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: $timeBtn;
  border-color: $timeBtn;
  box-shadow: -1px 0 0 0 $timeBtn;
}
// 日期选择器样式
/deep/ .el-date-editor .el-range-separator {
  width: 10%;
}
/deep/ .el-date-editor .el-range__icon {
  font-size: 20px;
  position: absolute;
  right: 8px;
  top: 2px;
}
// 单选按钮
.el-radio-button__inner,
.el-radio-group {
  align-self: center;
  .is-checked {
    /deep/ .el-radio__inner {
      background: $awardKind;
      border-color: $awardKind;
    }
    /deep/ .el-radio__inner::after {
      background-color: $base-color;
    }
    /deep/ .el-radio__label {
      color: $awardKind;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/bestPractice/AwardsList.vue